/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualRentDto } from '../../models/backend-actual-rent-dto';
import { BackendActualRentRequestDto } from '../../models/backend-actual-rent-request-dto';

export interface MonitoringActualsRentsUpdate$FormData$Params {
  id: number;
  body: BackendActualRentRequestDto;
}

export function monitoringActualsRentsUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsRentsUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualRentDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsRentsUpdate$FormData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualRentDto>;
    }),
  );
}

monitoringActualsRentsUpdate$FormData.PATH = '/api/monitoring/actuals/rents/{id}/';
